import get from 'lodash.get';
import moment from 'moment';
import { getActiveMenuByOffice, findMenuEventsByWeek, saveWeeklyMenu } from '@/services/weeklyMenu';
import { getWeekStartAndEndDate, parseWeek } from '@/helpers';

const setMenu = async ({ commit, rootGetters }) => {
  const user = rootGetters['user/getUser'];
  const officeName = get(user, 'officeName', '');
  if (!officeName) {
    throw new Error('User is not defined or the officeName is not set');
  }
  const responseWeeklyMenu = await getActiveMenuByOffice({ user });
  const findActiveWeeklyMenuByOffice = get(responseWeeklyMenu, 'data.findActiveWeeklyMenuByOffice');

  commit('SET_WEEK', findActiveWeeklyMenuByOffice);
  return findActiveWeeklyMenuByOffice;
};

const setDisabledDays = ({ commit }, disabledDay) => {
  commit('SET_DISABLED_DAYS', disabledDay);
};

const setDisabledEvents = ({ commit }, disabledEvent) => {
  commit('SET_DISABLED_EVENTS', disabledEvent);
};

const setDisableWeekFlag = ({ commit }, disabledWeekFlag) => {
  commit('SET_DISABLE_WEEK_FLAG', disabledWeekFlag);
};

const setWeekNumber = ({ commit }, weekNumber) => {
  commit('SET_WEEK_NUMBER', weekNumber);
};

const setSelectedWeek = ({ commit }, selectedWeek) => {
  const selectedWeekMoment = parseWeek(selectedWeek);
  const currentWeekMoment = parseWeek(moment());
  const weekNumber = selectedWeekMoment.diff(currentWeekMoment, 'week');
  commit('SET_SELECTED_WEEK', selectedWeek);
  commit('SET_WEEK_NUMBER', weekNumber);
};

const initializeWeekMenu = async ({ commit, dispatch, rootGetters }, { weekNumber }) => {
  const user = rootGetters['user/getUser'];
  const weekDates = getWeekStartAndEndDate(weekNumber);
  const findMenuEventsByWeekParameters = {
    startDate: weekDates.startDate.format('YYYY-MM-DD'),
    endDate: weekDates.endDate.format('YYYY-MM-DD'),
    office: user.office,
  };

  commit('SET_IS_LOADING_MENU', true);

  const menuEventsByWeek = await findMenuEventsByWeek(findMenuEventsByWeekParameters);

  const menuEventsInfo = get(menuEventsByWeek, 'data.findMenuEventsByWeek.menuEventsInfo');
  const canSubmit = get(menuEventsByWeek, 'data.findMenuEventsByWeek.canSubmit');
  commit('SET_IS_LOADING_MENU', false);
  dispatch('setIsDueDate', !canSubmit);

  if (menuEventsInfo.length) {
    commit('SET_WEEK', {
      startDate: findMenuEventsByWeekParameters.startDate,
      endDate: findMenuEventsByWeekParameters.endDate,
    });
    return menuEventsInfo;
  }
  return [];
};

const setIsDueDate = ({ commit }, isDueDate) => {
  commit('SET_IS_DUE_DATE', isDueDate);
};

const setNewMenuDefaultValues = ({ commit }) => {
  commit('VALIDATE_NEW_MENU', undefined);
  commit('VALIDATE_NEW_MENU_UPLOADS', undefined);
};

const validateMenu = async ({ commit }, { startDate, endDate, office }) => {
  const menuEventsByWeek = await findMenuEventsByWeek({ startDate, endDate, office });
  const menuIsValid =
    get(menuEventsByWeek, 'data.findMenuEventsByWeek.menuEventsInfo.length', false) === 0;
  commit('VALIDATE_NEW_MENU', menuIsValid);
};

const saveMenu = async ({ commit }, menuEvents) => {
  try {
    await saveWeeklyMenu(menuEvents);
    commit('VALIDATE_NEW_MENU_UPLOADS', true);
  } catch (error) {
    commit('VALIDATE_NEW_MENU_UPLOADS', false);
  }
};

export default {
  initializeWeekMenu,
  setMenu,
  setDisabledDays,
  setDisabledEvents,
  setDisableWeekFlag,
  setWeekNumber,
  setSelectedWeek,
  setIsDueDate,
  setNewMenuDefaultValues,
  validateMenu,
  saveMenu,
};



// WEBPACK FOOTER //
// ./store/modules/weeklyMenu/actions.js